<template>
    <div class="flex mb-2">
        <div class="w-auto inline-block">
            <p class="mb-0">
                <template v-if="showPassword">
                    {{ password }}
                </template>
                <template v-else>
                    <span v-html="maskedPassword"></span>
                </template>
            </p>
        </div>
        <button class="ml-auto text-green underline hover:no-underline" @click.stop="showPassword = !showPassword" id="toggle-password-visibility">
            {{ toggleButtonMessage }}
        </button>
    </div>
</template>
<script>
export default {
    props: {
        password: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            showPassword: false,
        }
    },

    computed: {

        passwordLength() {
            return this.password ? this.password.length : 5;
        },

        toggleButtonMessage() {
            return this.showPassword ? 'Hide' : 'Show';
        },

        maskedPassword() {
            return (new Array(this.passwordLength).fill('&bull;')).join('');
        },
    }
}
</script>
